import React, { useState } from "react";
import { Btn } from "../../styles/Button.styled";
import { Container } from "../../styles/Sidebar/UploadModal.styled";
import Popup from "../Popup/Popup";
import { useAppDispatch } from "../../hooks";
import { AttributeItem } from "./interfacesAttr";
import { Input } from "../inputs/Input";
import { Select } from "../inputs/Select";
import styles from "../../styles/Docs/Docs.module.css";
// import { CheckboxSingle } from "../inputs/Checkbox";
import { OptionsEditor } from "../inputs/OptionsEditor";
import { editAttribute } from "../../actions/attributes";
import { OptionsDocType } from "../inputs/OptionsDocType";
import { useMediaQuery } from "react-responsive";

export function EditAttributePopup({
  handleClose,
  singleAttr,
  singleType = false,
  optionsType,
  attributesCommon,
}: {
  handleClose: () => void;
  singleAttr?: AttributeItem | undefined;
  optionsType: any;
  singleType?: boolean;
  attributesCommon?: any;
}) {
  if (!singleAttr) return;
  const [activeSave, setActiveSave] = useState(false);
  const [title, setTitle] = useState(singleAttr?.title ?? "");
  // const [mandatory, setMandatory] = useState<boolean>(
  //   singleAttr?.mandatory ?? false,
  // );
  const [type, setType] = useState(singleAttr?.type);
  const [data, setData] = useState<
    OptionsProps | Record<string, string> | null
  >(singleAttr?.data ?? null);
  const [isDataValid, setIsDataValid] = useState(true);

  const dispatch = useAppDispatch();

  const initialOptions: Option[] = data
    ? Object.entries(data).map(([key, label]) => ({ key, label }))
    : [
        { label: "", key: "" },
        { label: "", key: "" },
      ];

  const handleOptionsUpdate = (options: Option[], isValid: boolean) => {
    const optionsObject = options.reduce(
      (acc, curr) => {
        if (curr.label && curr.key) {
          acc[curr.key] = curr.label;
        }
        return acc;
      },
      {} as Record<string, string>,
    );
    setData(optionsObject);
    setIsDataValid(isValid);
    setActiveSave(true);
  };

  // const handleCheckboxChange = (val: boolean) => {
  //   setMandatory(val);
  //   setActiveSave(true);
  // };
  const showOptionsEditor = type?.alias === "radio" || type?.alias === "select";

  const closePopup = () => handleClose();
  const isMobile = useMediaQuery({ maxWidth: 767 });

  const handleEdit = () => {
    const editedData = {
      title: title,
      type: type.id,
      // mandatory: mandatory,
      data: data,
    };
    dispatch(editAttribute(editedData, singleAttr.id));
    handleClose();
  };

  return (
    <Popup
      clickCloseButton={closePopup}
      style={{
        maxHeight: "90dvh",
        height: "max-content",
      }}
    >
      <h1 className={styles.popupH}>
        Редагування {singleType ? "типу" : "атрибуту"}
      </h1>
      <Container>
        <div className={styles.editPopupContent}>
          <div className={styles.inputColumn}>
            <Input
              label="Назва"
              placeholder="Вкажіть назву параметру"
              value={title}
              onChange={(e) => {
                setTitle(e);
                setActiveSave(true);
              }}
              isLabelFloating={true}
              labelStyle={{ background: "var(--white)" }}
            />
            {!singleType && (
              <Select
                label="Тип параметру"
                options={optionsType.list}
                disabled={true}
                value={type?.id}
                labelStyle={{ background: "var(--white)" }}
                onChange={(e) => {
                  setType(e);
                  setActiveSave(true);
                }}
              />
            )}
            {/* {!singleType && (
              <CheckboxSingle
                label="Обов'язковий до заповнення"
                checked={mandatory}
                onChange={handleCheckboxChange}
              />
            )} */}
            {showOptionsEditor && (
              <div className={styles.optionsSection}>
                <h2 className={styles.optionsTitle}>Варіанти значень списку</h2>
                <OptionsEditor
                  initialOptions={initialOptions}
                  onUpdate={handleOptionsUpdate}
                  inputLabelStyle={{ background: "var(--white)" }}
                  style={{
                    overflowY: "auto",
                    maxHeight: isMobile ? "calc(90dvh - 380px)" : "260px",
                  }}
                />
              </div>
            )}
            {singleType && (
              <div className={styles.optionsSection}>
                <h2 className={styles.optionsTitle}>
                  Додаткові параметри типу документу
                </h2>
                <OptionsDocType
                  initialOptions={initialOptions}
                  onUpdate={handleOptionsUpdate}
                  style={{
                    overflowY: "auto",
                    maxHeight: isMobile ? "172px" : "260px",
                  }}
                  attributesCommon={attributesCommon}
                />
              </div>
            )}
          </div>
        </div>
        <div className={styles.buttonContainer}>
          <Btn
            type="button"
            $width="100%"
            $color="var(--blue)"
            $marginTop="0"
            style={{ flex: 1 }}
            onClick={closePopup}
            $background="var(--sidebar-hover)"
            $heightMobile="40px"
          >
            Відмінити
          </Btn>

          <Btn
            style={{ flex: 1 }}
            type="button"
            $width="100%"
            $color="var(--white)"
            $marginTop="0"
            onClick={handleEdit}
            $background="var(--blue)"
            $heightMobile="40px"
            disabled={!activeSave || !isDataValid}
          >
            Зберегти
          </Btn>
        </div>
      </Container>
    </Popup>
  );
}
